import { render, staticRenderFns } from "./Resident.vue?vue&type=template&id=134dfb5f&"
import script from "./Resident.vue?vue&type=script&lang=js&"
export * from "./Resident.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports